module.exports = __webpack_public_path__ + "static/media/logo171.1a94d18f.png";